import React from 'react';
import './LoadingModal.css';

const LoadingModal = ({ isOpen, status, message, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal">

        <button className="modal-close-btn" onClick={onClose}>
          ✖
        </button>
        
        {status === 'loading' && (
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>{message || 'Processing payment...'}</p>
          </div>
        )}
        
        {status === 'success' && (
          <div className="modal-success">
            <div className="success-icon">✓</div>
            <p>{message || 'Payment successful!'}</p>
            <button className="modal-accept-btn" onClick={onClose}>
              Accept
            </button>
          </div>
        )}
        
        {status === 'error' && (
          <div className="modal-error">
            <div className="error-icon">✕</div>
            <p>{message || 'Payment failed. Please try again.'}</p>
            <button className="modal-retry-btn" onClick={onClose}>
              Try Again
            </button>
          </div>
        )}

        {status === 'info' && (
          <div className="modal-info">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingModal;